

























































































































































































import Vue from 'vue'
import Loading from '@/components/globals/basics/Loading/Loading.vue'
import PageDefaultLayout from '@/components/globals/PageDefaultLayout.vue'
import ToggleList, {
  ToggleListItem,
} from '@/components/globals/basics/ToggleList.vue'
import ProgramPagination from '@/components/program/ProgramPagination.vue'
import OnlineProgramCard from '@/components/onlineProgram/OnlineProgramCard.vue'
import TimetableCard from '@/components/program/TimetableCard.vue'
import {
  listOnlineProgram,
  ProgramWithTimetables,
  PagerMeta as ProgramsPagerMeta,
  ViewMode,
} from '@/core/Programs'
import {
  listOnlineTimetable,
  ListTimetableItem,
  PagerMeta as TimetablesPagerMeta,
} from '@/core/Timetables'
import { Meta } from '@/tools/page'

const PAGE_TITLE = 'オンラインプログラム一覧'
const PAGE_META: Meta[] = [
  {
    name: 'description',
    content:
      'GYYMで利用できるオンラインプログラムです。今話題のジムや人気のプログラムを見つけて気軽にフィットネスを始めましょう！',
  },
]

const programSortItems: ToggleListItem[] = [
  {
    label: '日付順',
    value: {
      sortBy: 'minTimetableStartAt',
      order: 'asc',
    },
  },
  {
    label: '価格順',
    value: {
      sortBy: 'minTimetablePoint',
      order: 'asc',
    },
  },
  {
    label: '新着順',
    value: {
      sortBy: 'createdAt',
      order: 'desc',
    },
  },
]

const timetableSortItems: ToggleListItem[] = [
  {
    label: '日付順',
    value: {
      sortBy: 'start_at',
      order: 'asc',
    },
  },
  {
    label: '価格順',
    value: {
      sortBy: 'point',
      order: 'asc',
    },
  },
]

export default Vue.extend({
  components: {
    ToggleList,
    PageDefaultLayout,
    OnlineProgramCard,
    TimetableCard,
    ProgramPagination,
    Loading,
  },
  data() {
    return {
      ViewMode,
      viewMode: ViewMode.PROGRAMS,
      isFetchingPrograms: false,
      isFetchingTimetables: false,
      programSortItems,
      timetableSortItems,
      currentSortValue: { ...programSortItems[0].value },
      programs: [] as ProgramWithTimetables[],
      timetables: [] as ListTimetableItem[],
      programsMeta: {} as ProgramsPagerMeta,
      timetablesMeta: {} as TimetablesPagerMeta,
    }
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.$setPageTitle(PAGE_TITLE)
    this.$setPageMeta(PAGE_META)

    this.fetchData()
  },
  methods: {
    changeViewMode(mode: ViewMode) {
      this.viewMode = mode

      // ソートをviewModeに応じて切り替える
      switch (mode) {
        case ViewMode.TIMETABLES:
          this.currentSortValue = { ...timetableSortItems[0].value }
          break
        case ViewMode.PROGRAMS:
        default:
          this.currentSortValue = { ...programSortItems[0].value }
      }

      // データを取得
      this.fetchData()
    },
    handleSortChange(value: ToggleListItem) {
      this.currentSortValue = value
      this.$router
        .push({
          path: this.$route.path,
          query: { ...this.$route.query, page: undefined },
        })
        .catch(() => {
          // 同一パスの場合はNavigationDuplicatedになるため、watchからではなくこちらからfetchする
          this.fetchData()
        })
    },
    async fetchData() {
      switch (this.viewMode) {
        case ViewMode.TIMETABLES:
          this.fetchTimetablesData()
          break
        case ViewMode.PROGRAMS:
        default:
          this.fetchProgramsData()
      }
    },
    async fetchProgramsData() {
      this.isFetchingPrograms = true

      const { data: programs, meta } = await listOnlineProgram({
        // オンラインプログラムの件数が少ないため、満席のプログラムも表示する
        showFullReservations: true,
        ...this.currentSortValue,
        page: this.$route.query.page || 1,
      })

      this.programs = programs
      this.programsMeta = meta
      this.isFetchingPrograms = false
    },
    async fetchTimetablesData() {
      this.isFetchingTimetables = true

      const { data: timetables, meta } = await listOnlineTimetable({
        // オンラインプログラムの件数が少ないため、満席のタイムテーブルも表示する
        showFullReservations: true,
        ...this.currentSortValue,
        page: this.$route.query.page || 1,
      })

      this.timetables = timetables
      this.timetablesMeta = meta
      this.isFetchingTimetables = false
    },
  },
})
